/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitextplacepromptplaceholder4Inputs */

const en_aitextplacepromptplaceholder4 = /** @type {(inputs: Aitextplacepromptplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Family-run cafe with its own bakery, terrace and all-day breakfast`)
};

const de_aitextplacepromptplaceholder4 = /** @type {(inputs: Aitextplacepromptplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Familiengeführtes Café mit Hausbäckerei, Terrasse und Frühstück den ganzen Tag`)
};

/**
* | output |
* | --- |
* | "e.g. Family-run cafe with its own bakery, terrace and all-day breakfast" |
*
* @param {Aitextplacepromptplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitextplacepromptplaceholder4 = /** @type {((inputs?: Aitextplacepromptplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitextplacepromptplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitextplacepromptplaceholder4(inputs)
	return de_aitextplacepromptplaceholder4(inputs)
});
export { aitextplacepromptplaceholder4 as "aiTextPlacePromptPlaceholder" }